import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { COLOR } from '@src/styles/color';
import ReactMarkdown from 'react-markdown';
import Typography from '@src/new-components/Typography';
import { HeaderRow, RulesContainer } from '../index.style';

const Rules = ({ rulesDisplay, isLoading }) => {
  const { t } = useTranslation();

  return (
    <RulesContainer>
      <HeaderRow>
        <Box style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <Typography variant="body-20-bold" color={COLOR.darkGray}>
            📖 {t('rules')}
          </Typography>
        </Box>
      </HeaderRow>
      {isLoading ? (
        <Skeleton variant="rectangular" width="100%" height="200px" />
      ) : (
        <Typography
          className="rules-text"
          variant="body-14-regular"
          color={COLOR.descriptionGray}
        >
          <ReactMarkdown>{rulesDisplay?.replace(/\\n/g, '\n')}</ReactMarkdown>
        </Typography>
      )}
    </RulesContainer>
  );
};

export default Rules;
